import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  title: {
    id: 'course-authoring.course-outline.empty-placeholder.title',
    defaultMessage: 'Aún no has agregado contenido a este curso.',
  },
  button: {
    id: 'course-authoring.course-outline.empty-placeholder.button.new-section',
    defaultMessage: 'Nueva sección',
  },
  tooltip: {
    id: 'course-authoring.course-outline.empty-placeholder.button.tooltip',
    defaultMessage: 'Haz clic para agregar una nueva sección',
  },
});

export default messages;
